<script>
import isEqual from 'lodash.isequal'
import Modal from '@/components/atoms/Modal'
import ButtonLoader from '@/components/atoms/ButtonLoader'
import ContentLine from '@/components/atoms/ContentLine'

import FormValidation from '@/components/atoms/FormValidation'
import InputLine from '@/components/atoms/inputlib/components/InputLine'
import InputTextarea from '@/components/atoms/inputlib/components/InputTextarea'
import InputPhone from '@/components/atoms/inputlib/components/InputPhone'

export default {
    name: 'ModalEdit',

    components: {
        Modal,
        ContentLine,
        ButtonLoader,
        FormValidation,
        InputPhone,
        InputTextarea,
        InputLine,
    },

    props: {
        value: {
            type: Object,
            default: () => {},
            required: true,
        },
        save: {
            type: Function,
            default: () => false,
            required: true,
        },
    },

    data() {
        return {
            model: null,
            loading: false,
            input: null,
        }
    },
    computed: {
        isDirty() {
            return !isEqual(this.model, this.value)
        },
    },

    methods: {
        getValue(key) {
            if (!Array.isArray(key)) key = [key]
            return key.reduce((text, keyString) => {
                return text
                    ? `${text} ${this.splitKeys(keyString, this.model)}`
                    : this.splitKeys(keyString, this.model)
            }, undefined)
        },
        splitKeys(key, model) {
            return key.split('.').reduce((obj, keyString) => {
                return obj[keyString]
            }, model)
        },
        isLive(validationType) {
            switch (validationType) {
                case 'phone':
                    return true
                default:
                    return false
            }
        },
        getType(type) {
            if (!Array.isArray(type)) type = [type]
            return type.map((inputType) => {
                switch (inputType) {
                    case 'line':
                        return 'input-line'
                    case 'textarea':
                        return 'input-textarea'
                    case 'phone':
                        return 'input-phone'
                    default:
                        return 'input-line'
                }
            })
        },
        getSetting(setting, index) {
            if (!setting) return
            if (!Array.isArray(setting)) setting = [setting]
            return setting[index]
        },
        async editValue(step) {
            await this.setSlideLeft()
            this.step = step
        },
        setValue(key, inputIndex, value) {
            if (!Array.isArray(key)) key = [key]
            key = key[inputIndex].split('.')
            let currentObj = this.model

            for (let i = 0; i < key.length - 1; i++) {
                if (!(key[i] in currentObj)) return
                currentObj = currentObj[key[i]]
            }
            currentObj[key[key.length - 1]] = value
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj))
        },
        open(input) {
            if (input) {
                this.input = input
                this.model = this.clone(this.value)
                this.$refs.ModalEdit.openModal()
            }
        },
        close() {
            this.$refs.ModalEdit.closeModal()
            this.$nextTick(() => {
                this.model = undefined
            })
        },
        submit() {
            this.$refs.form.formSubmit()
        },
        async saveModel() {
            try {
                this.loading = true
                this.model = await this.save(this.model)
                this.$emit('input', this.clone(this.model))
                this.close()
            } catch (e) {
                // eslint-disable-next-line no-console
                console.error(`Error during edit:`, e)
            } finally {
                this.loading = false
            }
        },
    },
}
</script>

<template lang="pug">
modal(ref="ModalEdit" close-class="btn-white-primary" scroll)
    template(v-slot:header)
        .modal-header-text {{ $t('base.edit') }}
    template(v-slot:body)                 
        form-validation(ref="form" @submit="saveModel")         
            component(
                v-for="(type, index) in getType(input.type)"
                :is="type"
                :live="isLive(getSetting(input.validationType, index))"
                :type="getSetting(input.validationType, index)"
                :value="getValue(getSetting(input.key, index))" 
                :validate="getSetting(input.validate, index)" 
                :required="getSetting(input.required, index)" 
                :key="`input-${_uid}-${index}`" 
                @input="setValue(input.key, index, $event)") {{ $t(getSetting(input.inputLabel, index)) }}
           
    template(v-slot:footer)
        button-loader.btn.btn-primary.btn-block(@click="submit" :loading="loading" :disabled="!isDirty" inline) {{ $t('base.save') }}
      
</template>
